/** "2026-09-25" -> "25 Sep 2026". A plain day, so it reads the same wherever the viewer is. */
export function dayOf(iso: string | null | undefined): string {
  if (!iso) return '—';
  const [year, month, day] = iso.slice(0, 10).split('-').map(Number);
  if (!year || !month || !day) return '—';
  return new Date(year, month - 1, day).toLocaleDateString([], { day: 'numeric', month: 'short', year: 'numeric' });
}

const DOLLARS = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });

/** 612 -> "$612.00"; -612 -> "-$612.00". */
export function dollars(amount: number | null | undefined): string {
  return amount == null ? '—' : DOLLARS.format(amount);
}
